import { useEffect, useRef } from "react";
import { CalendarClock, MessageCircle } from "lucide-react";
import { useBookCall } from "@/pages/Landing";

export default function MobileStickyCTA() {
  const { open } = useBookCall();
  const barRef = useRef(null);

  // Beat the Emergent badge's inline z-index:9999 !important
  useEffect(() => {
    if (barRef.current) {
      barRef.current.style.setProperty("z-index", "99999", "important");
    }
  }, []);

  return (
    <div
      ref={barRef}
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed left-0 right-0 bg-black/90 backdrop-blur-xl border-t border-white/10 px-3 py-2.5 flex items-center gap-2"
      style={{
        bottom: "max(64px, calc(64px + env(safe-area-inset-bottom)))",
      }}
    >
      <a
        href="#contact"
        className="flex-1 flex items-center justify-center gap-1.5 py-2.5 border border-white/20 font-mono text-[11px] uppercase tracking-widest text-white/80 hover:text-neon-cyan hover:border-neon-cyan transition-all"
      >
        <MessageCircle size={12} /> Message
      </a>
      <button
        onClick={() => open()}
        data-testid="mobile-sticky-book"
        className="flex-[2] flex items-center justify-center gap-1.5 py-2.5 bg-neon-orange text-[#05050A] font-mono text-[11px] uppercase tracking-widest font-bold hover:bg-neon-cyan transition-colors"
      >
        <CalendarClock size={12} /> Reserve 15-min Call
      </button>
    </div>
  );
}
